package com.dignicate.web

import com.dignicate.web.style.AppStyleSheet
import com.dignicate.web.ui.screens.MainScreen
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.renderComposable

fun main() {
    console.log("=================================")
    console.log("[Main] Application starting...")
    console.log("=================================")

    renderComposable(rootElementId = "root") {
        console.log("[Main] renderComposable called")
        Style(AppStyleSheet)
        MainScreen()
    }

    console.log("[Main] main() function completed")
}
